import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../../../util/reactIntl';
import clsx from 'clsx';
import { NamedLink } from '../../../../components';
import SectionHeroImages from './SectionHeroImages';
import { useElementSize } from '@mantine/hooks';
import config from '../../../../config';
import flowers from '../../../../assets/flowers.png';
import breakpoints from '../../../../styles/globals.module.scss';
import css from './SectionHero.module.css';

// hero section content component
const HeroContentComponent = () => {
  return (
    <div className={css.heroContent}>
      <h1 className={css.heroMainTitle}>
        <FormattedMessage id="SectionHero.title" />
      </h1>
      <h2 className={css.heroSubTitle}>
        <FormattedMessage id="SectionHero.subTitle" />
      </h2>
      <div className={css.heroButtonWrapper}>
        <NamedLink
          name="SearchPage"
          to={{
            search:
            '?sort=-createdAt&address=Portugal&bounds=42.154276%2C-6.189158%2C29.9501178%2C-31.3687699',
          }}
          className={css.heroCustomerCTAButton}
        >
          <FormattedMessage id="SectionHero.browseButton" />
        </NamedLink>
      </div>
    </div>
  );
};

// hero section SA content component
const HeroSAContentComponent = (props) => {
  const { handleOnClick } = props;

  return (
    <div className={css.heroContent}>
      <h1 className={css.heroMainTitle}>
        <FormattedMessage id="SectionHeroSA.title" />
      </h1>
      <h2 className={css.heroSubTitle}>
        <FormattedMessage id="SectionHeroSA.subTitle" />
      </h2>
      <div className={css.heroButtonWrapper}>
        <NamedLink
          name="AffiliateSignupPage"
          params={{ userType: 3 }}
          className={css.heroSATOButton}
        >
          <FormattedMessage id="SectionHeroSA.browseButton" />
        </NamedLink>
        <a name="SearchPage" href="#how-it-works-SA" className={css.heroSATOSecondaryButton} onClick={handleOnClick}>
          <FormattedMessage id="SectionHero.browseButtonSecondary" />
        </a>
      </div>
    </div>
  );
};

// hero section TO content component
const HeroTOContentComponent = (props) => {
  const { handleOnClick } = props;

  return (
    <div className={css.heroContent}>
      <h1 className={css.heroMainTitle}>
        <FormattedMessage id="SectionHeroTO.title" />
      </h1>
      <h2 className={css.heroSubTitle}>
        <FormattedMessage id="SectionHeroTO.subTitle" />
      </h2>
      <div className={css.heroButtonWrapper}>
        <NamedLink name="NewListingPage" className={css.heroSATOButton}>
          <FormattedMessage id="SectionHeroTO.browseButton" />
        </NamedLink>
        <a name="SearchPage" href="#how-it-works-TO" className={css.heroSATOSecondaryButton}  onClick={handleOnClick}>
          <FormattedMessage id="SectionHero.browseButtonSecondary" />
        </a>
      </div>
    </div>
  );
};
// hero section BnB content component
const HeroBnBContentComponent = () => {
  return (
    <div className={css.heroContent}>
      <h1 className={css.heroMainTitle}>
        <FormattedMessage id="SectionHeroBnbs.title" />
      </h1>
      <div className={css.heroButtonWrapper}>
        <NamedLink name="AffiliateSignupPage" className={css.heroBnbsButton}>
          <FormattedMessage id="SectionHeroSA.browseButton" />
        </NamedLink>
      </div>
    </div>
  );
};

const HeroFactory = (props) => {
  const { pathName, heroWidth, handleOnClick } = props;

  switch (pathName) {
    case '/home':
      return (
        <>
          <SectionHeroImages heroWidth={heroWidth} bnbPage={false} />
          <HeroContentComponent />
        </>
      );
    case '/tour-operators':
      return (
        <>
          <SectionHeroImages heroWidth={heroWidth} bnbPage={false} />
          <HeroTOContentComponent handleOnClick={handleOnClick} />
        </>
      );
    case '/affiliates':
      return (
        <>
          <SectionHeroImages heroWidth={heroWidth} bnbPage={false} />
          <HeroSAContentComponent handleOnClick={handleOnClick} />
        </>
      );
    case '/bnbs':
      return (
        <>
          <SectionHeroImages heroWidth={heroWidth} bnbPage={true} />
          <HeroBnBContentComponent />;
        </>
      );
    default:
      break;
  }
};


const SectionHero = (props) => {
  const { rootClassName, className, location, handleOnClick } = props;

  const pathName = location.pathname
  const classes = clsx(rootClassName || css.root, className);

  const { ref, width: heroWidth } = useElementSize();

  const aspectRatio = heroWidth > breakpoints.viewportMediumPixels ? 500 / 2500 : 313 / 430;
  let heroHeight = Math.floor(heroWidth * aspectRatio);
  if (heroWidth <= breakpoints.viewportMediumPixels)
    heroHeight = 313;
  else 
    heroHeight = Math.min(500,Math.max(313,heroHeight)); // Ensuring it stays within 313 and 500 px

  return (
    <div
      className={classes}
      ref={ref}
      style={heroWidth > 0 ? { minHeight: heroHeight + 'px', maxHeight: heroHeight + 'px' } : {}}
    >
      {heroWidth > 0 ? <HeroFactory heroWidth={heroWidth} pathName={pathName} handleOnClick={handleOnClick} /> : null}
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
